export default "__VITE_ASSET__BHcjG3XN__"